import React from "react";

const CustomerType7View = () => null;

export default CustomerType7View;
